module.exports = __webpack_public_path__ + "static/media/flag-mg.43b4ed48.webp";